// components/PitchDeck/06_TractionMilestones.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function TractionMilestones() {
    return (
        <div className="min-h-screen flex items-center bg-gray-50 py-20">
            <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-12">
                    Traction & Milestones
                </h2>
                <div className="grid md:grid-cols-2 gap-12">
                    <div className="bg-white p-10 rounded-2xl shadow-xl">
                        <h3 className="text-3xl font-bold text-[#4285F4] mb-6">Current</h3>
                        <ul className="text-xl text-left space-y-6">
                            <li>Company registered: March 2025</li>
                            <li>Launched: November 2025</li>
                            <li>First paying customer: December 1, 2025</li>
                            <li>Customer profile: ₦15M daily sales processed</li>
                            <li>Revenue to date: USD 1,100</li>
                            <li>Total invested: USD 2,500</li>
                            <li>Completely bootstrapped to first revenue</li>
                        </ul>
                    </div>
                    <div className="bg-white p-10 rounded-2xl shadow-xl">
                        <h3 className="text-3xl font-bold text-[#4285F4] mb-6">Next</h3>
                        <ul className="text-xl text-left space-y-6">
                            <li>Capitalize fast on our low-burn and strong market fit</li>
                            <li>10–15 paying customers in next 6 months</li>
                            <li>Monthly break-even: 16–18 customers</li>
                            <li>Seed funding within 12 months</li>
                            <li>V2 enhancements: Deeper AI, mobile app</li>
                        </ul>
                    </div>
                </div>
                <p className="mt-16 text-2xl font-bold text-gray-900">
                    Strong proof: Auditor-recommended first customer — real market fit.
                </p>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-700/40 rounded-full text-gray-700 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="/pitch/business-model">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}